import { useFormSubmissionSignatureQuery } from '~/lib/Queries';
import PadlockIcon from '../icons/PadlockIcon';
import DownloadIcon from '../icons/DownloadIcon';
import WarningCircleIcon from '../icons/WarningCircleIcon';
import { FC, useCallback, useMemo } from 'react';
import Tooltip from '../Tooltip';
import { onDownloadClick } from './SignatureHeader.utils';
import TStrings from './SignatureHeader.i18n';
import Loading from '../Loading';

type SignatureHeaderProps = {
    formSubmissionId: number;
    hideDownloadButton?: boolean;
};
const SignatureHeader: FC<SignatureHeaderProps> = ({
    formSubmissionId,
    hideDownloadButton = false,
}) => {
    const { data, isLoading } =
        useFormSubmissionSignatureQuery(formSubmissionId);

    const onDownloadClickCallback = useCallback(async () => {
        return onDownloadClick(data?.signatureStatus, data?.signedDocUrl);
    }, [data]);

    const signatureStatusData = useMemo(() => {
        switch (data?.signatureStatus) {
            case 'SignatureInvalid':
                return {
                    text: TStrings.SIGNATURE_INVALID,
                    className: 'text-red-500',
                };
            case 'Unsigned':
                return {
                    text: TStrings.SIGNATURE_UNSIGNED,
                    className: 'text-yellow-500',
                };
            case 'SignatureValid':
            default:
                return null;
        }
    }, [data?.signatureStatus]);

    return (
        <>
            {isLoading && <Loading className="px-1" hideMessage />}
            {!hideDownloadButton && data?.signedDocUrl ? (
                <button
                    onClick={onDownloadClickCallback}
                    type="button"
                    className="flex text-blue-500 px-1"
                >
                    <Tooltip
                        tooltipId="downloadTooltip"
                        message={TStrings.DIALOG_ICON_TOOLTIP}
                    >
                        <DownloadIcon />
                    </Tooltip>
                </button>
            ) : null}

            {signatureStatusData?.text && (
                <div className="flex cursor-pointer text-red-500 px-1">
                    <Tooltip
                        tooltipId="signatureStatusTooltip"
                        message={signatureStatusData?.text}
                    >
                        <WarningCircleIcon
                            className={signatureStatusData?.className}
                        />
                    </Tooltip>
                </div>
            )}
            <div className="flex cursor-pointer px-1">
                <Tooltip
                    tooltipId="signatureLockTooltip"
                    message={TStrings.LOCK_ICON_TOOLTIP}
                >
                    <PadlockIcon />
                </Tooltip>
            </div>
        </>
    );
};

export default SignatureHeader;
